import React from "react";

const BellIcon = ({ className }: { className?: string }) => {
  return (
    <>
      <svg
        width="13"
        height="17"
        viewBox="0 0 13 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M6.5 16.4219C7.39375 16.4219 8.125 15.6906 8.125 14.7969H4.875C4.875 15.2279 5.04621 15.6412 5.35095 15.9459C5.6557 16.2507 6.06902 16.4219 6.5 16.4219ZM11.375 11.5469V7.48438C11.375 4.99 10.0425 2.90187 7.71875 2.34937V1.79688C7.71875 1.1225 7.17438 0.578125 6.5 0.578125C5.82562 0.578125 5.28125 1.1225 5.28125 1.79688V2.34937C2.94938 2.90187 1.625 4.98187 1.625 7.48438V11.5469L0 13.1719V13.9844H13V13.1719L11.375 11.5469Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export default BellIcon;
